import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var HorizontalBarChart02 = function HorizontalBarChart02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17 9.5v3.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437c-.2139.109-.4939.109-1.054.109H3m10 0v3.4c0 .5601 0 .8401-.109 1.054a1 1 0 0 1-.437.437c-.2139.109-.4939.109-1.054.109H3M3 2v20M3 9.5h16.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 8.74 21 8.46 21 7.9V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 4.5 19.9601 4.5 19.4 4.5H3z"
    })
  }));
};
export default HorizontalBarChart02;